// extracted by mini-css-extract-plugin
export default {"container":"Integration_container__f1cS4","body":"Integration_body__mdVK7"};